<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter1nanyang">CHAPTER 1 - NANYANG</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter2guardingthecity">CHAPTER 2 - GUARDING THE CITY</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter3huangzhong">CHAPTER 3 - HUANG ZHONG</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter4zhangmancheng">CHAPTER 4 - ZHANG MANCHENG</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter5worry">CHAPTER 5 - WORRY</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter6confirmationofaphrase">CHAPTER 6 - CONFIRMATION OF A PHRASE</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter7warofsiege">CHAPTER 7 - WAR OF SIEGE</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter8yellowtowelelite">CHAPTER 8 - YELLOWTOWEL ELITE</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter9killerweapon" title="Link target outside of Sample">CHAPTER 9 - KILLER WEAPON</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter10liupingsadvice" title="Link target outside of Sample">CHAPTER 10 - LIU PING'S ADVICE</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter11delusion" title="Link target outside of Sample">CHAPTER 11 - DELUSION</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter12courtyard" title="Link target outside of Sample">CHAPTER 12 - COURTYARD</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter13difficulties" title="Link target outside of Sample">CHAPTER 13 - DIFFICULTIES</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter14soldiergeneral" title="Link target outside of Sample">CHAPTER 14 - SOLDIER GENERAL</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter15abitterstruggleatthecitygate" title="Link target outside of Sample">CHAPTER 15 - A BITTER STRUGGLE AT THE CITY GATE</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter16citybreaking" title="Link target outside of Sample">CHAPTER 16 - CITY-BREAKING</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter17retreat" title="Link target outside of Sample">CHAPTER 17 - RETREAT</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter18deadend" title="Link target outside of Sample">CHAPTER 18 - DEAD-END</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter19surprisedendings" title="Link target outside of Sample">CHAPTER 19 - SURPRISED ENDINGS</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter20exhort" title="Link target outside of Sample">CHAPTER 20 - EXHORT</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter21subdue" title="Link target outside of Sample">CHAPTER 21 - SUBDUE</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter22lucescalamity" title="Link target outside of Sample">CHAPTER 22 - LUCE'S CALAMITY</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter23dongzhuosinfamy" title="Link target outside of Sample">CHAPTER 23 - DONG ZHUO'S INFAMY</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter24captive" title="Link target outside of Sample">CHAPTER 24 - CAPTIVE</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter25westcoldarmy" title="Link target outside of Sample">CHAPTER 25 - WEST COLD ARMY</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter26requestbyliupingandgongdu" title="Link target outside of Sample">CHAPTER 26 - REQUEST BY LIU PING AND GONG DU</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter27huangzhongwasdrunk" title="Link target outside of Sample">CHAPTER 27 - HUANG ZHONG WAS DRUNK</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter28phoenixmountain" title="Link target outside of Sample">CHAPTER 28 - PHOENIX MOUNTAIN</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter29dissuade" title="Link target outside of Sample">CHAPTER 29 - DISSUADE</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter30ifyouwanttofightfight" title="Link target outside of Sample">CHAPTER 30 - IF YOU WANT TO FIGHT FIGHT!</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter31phoenixmountainwar" title="Link target outside of Sample">CHAPTER 31 - PHOENIX MOUNTAIN WAR</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter32xanthopanax" title="Link target outside of Sample">CHAPTER 32 - XANTHOPANAX</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter33firsttimeinluoyang" title="Link target outside of Sample">CHAPTER 33 - FIRST TIME IN LUOYANG</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter34vips" title="Link target outside of Sample">CHAPTER 34 - VIPS</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter35relaxationandfortuitousencounters" title="Link target outside of Sample">CHAPTER 35 - RELAXATION AND FORTUITOUS ENCOUNTERS</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter36boldmanandscholar" title="Link target outside of Sample">CHAPTER 36 - BOLD MAN AND SCHOLAR</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter37fight" title="Link target outside of Sample">CHAPTER 37 - FIGHT</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter38followme" title="Link target outside of Sample">CHAPTER 38 - FOLLOW ME</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter39vishnuparti" title="Link target outside of Sample">CHAPTER 39 - VISHNU(PART I)</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter40vishnupartii" title="Link target outside of Sample">CHAPTER 40 - VISHNU(PART II)</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter41vishnulastpart" title="Link target outside of Sample">CHAPTER 41 - VISHNU(LAST PART)</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter42centerfiveyear" title="Link target outside of Sample">CHAPTER 42 - CENTER FIVE YEAR</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter43decadalplotting" title="Link target outside of Sample">CHAPTER 43 - DECADAL PLOTTING</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter44liuhongsmind" title="Link target outside of Sample">CHAPTER 44 - LIU HONG'S MIND</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter45eighthcommanderinchief" title="Link target outside of Sample">CHAPTER 45 - EIGHTH COMMANDER-IN-CHIEF</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter46caocaosreturntobeijing" title="Link target outside of Sample">CHAPTER 46 - CAO CAO'S RETURN TO BEIJING</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter47chess" title="Link target outside of Sample">CHAPTER 47 - CHESS</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter48guojiasanalysis" title="Link target outside of Sample">CHAPTER 48 - GUO JIA'S ANALYSIS</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter49guojia" title="Link target outside of Sample">CHAPTER 49 - GUO JIA</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter50visitingchengli" title="Link target outside of Sample">CHAPTER 50 - VISITING CHENG LI</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter51chenglichengyu" title="Link target outside of Sample">CHAPTER 51 - CHENG LI CHENG YU?</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter52afortuitousencounteratthetigerscage" title="Link target outside of Sample">CHAPTER 52 - A FORTUITOUS ENCOUNTER AT THE TIGER'S CAGE</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter53chunyuzhong" title="Link target outside of Sample">CHAPTER 53 - CHUNYUZHONG</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter54thieveshavegreatpower" title="Link target outside of Sample">CHAPTER 54 - THIEVES HAVE GREAT POWER</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter55smallsoldier" title="Link target outside of Sample">CHAPTER 55 - SMALL SOLDIER</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter56bloodywarinthetigersjailpass" title="Link target outside of Sample">CHAPTER 56 - BLOODY WAR IN THE TIGER'S JAIL PASS</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter57thetigersjailvictory" title="Link target outside of Sample">CHAPTER 57 - THE TIGER'S JAIL VICTORY</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter58unexpectedgoodnews" title="Link target outside of Sample">CHAPTER 58 - UNEXPECTED GOOD NEWS</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter59empressheshate" title="Link target outside of Sample">CHAPTER 59 - EMPRESS HE'S HATE</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter60liuyingji" title="Link target outside of Sample">CHAPTER 60 - LIU YINGJI</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter61alonelyhero" title="Link target outside of Sample">CHAPTER 61 - A LONELY HERO</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter62eighthcommanderinchiefsmeeting" title="Link target outside of Sample">CHAPTER 62 - EIGHTH COMMANDER-IN-CHIEF'S MEETING</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter63unexpectedsetup" title="Link target outside of Sample">CHAPTER 63 - UNEXPECTED SETUP</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter64takeoverthesouthofthecity" title="Link target outside of Sample">CHAPTER 64 - TAKE OVER THE SOUTH OF THE CITY</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter65conflict" title="Link target outside of Sample">CHAPTER 65 - CONFLICT</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter66thecompetitionofspiritandspirit" title="Link target outside of Sample">CHAPTER 66 - THE COMPETITION OF SPIRIT AND SPIRIT</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter67wuqong" title="Link target outside of Sample">CHAPTER 67 - WU QONG</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter68resolve" title="Link target outside of Sample">CHAPTER 68 - RESOLVE</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter69dongzhuoandliru" title="Link target outside of Sample">CHAPTER 69 - DONG ZHUO AND LI RU</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter70eastwardadvance" title="Link target outside of Sample">CHAPTER 70 - EASTWARD ADVANCE</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter71nightattack" title="Link target outside of Sample">CHAPTER 71 - NIGHT ATTACK</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter72yuanshao" title="Link target outside of Sample">CHAPTER 72 - YUAN SHAO</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter73empresshescompromise" title="Link target outside of Sample">CHAPTER 73 - EMPRESS HE'S COMPROMISE</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter74handisdeath" title="Link target outside of Sample">CHAPTER 74 - HANDI'S DEATH</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter75discernmentofbluntprince" title="Link target outside of Sample">CHAPTER 75 - DISCERNMENT OF BLUNT PRINCE</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter76assassination" title="Link target outside of Sample">CHAPTER 76 - ASSASSINATION</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter77therighttosendtroops" title="Link target outside of Sample">CHAPTER 77 - THE RIGHT TO SEND TROOPS</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter78qinghegong" title="Link target outside of Sample">CHAPTER 78 - QING HE GONG</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter79compassionateheart" title="Link target outside of Sample">CHAPTER 79 - COMPASSIONATE HEART</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter80disorientation" title="Link target outside of Sample">CHAPTER 80 - DISORIENTATION</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter81gotobedchamber" title="Link target outside of Sample">CHAPTER 81 - GO TO BEDCHAMBER</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter82end" title="Link target outside of Sample">CHAPTER 82 - END</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter83adultery" title="Link target outside of Sample">CHAPTER 83 - ADULTERY</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter84bigdipperyuanshao" title="Link target outside of Sample">CHAPTER 84 - BIG DIPPER YUAN SHAO</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter85accordingtothefacts" title="Link target outside of Sample">CHAPTER 85 - ACCORDING TO THE FACTS</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter86caocaopai" title="Link target outside of Sample">CHAPTER 86 - CAO CAO PAI</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter87theunruly" title="Link target outside of Sample">CHAPTER 87 - THE UNRULY</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter88fortuitousencounter" title="Link target outside of Sample">CHAPTER 88 - FORTUITOUS ENCOUNTER</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter89unionarmy" title="Link target outside of Sample">CHAPTER 89 - UNION ARMY</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter90firsttrimesteroflubu" title="Link target outside of Sample">CHAPTER 90 - FIRST TRIMESTER OF LUBU</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter91epilogue" title="Link target outside of Sample">CHAPTER 91 - EPILOGUE</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter92decadentdisorder" title="Link target outside of Sample">CHAPTER 92 - DECADENT DISORDER</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter93constructionhall" title="Link target outside of Sample">CHAPTER 93 - CONSTRUCTION HALL</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter94princesstenthousandyears" title="Link target outside of Sample">CHAPTER 94 - PRINCESS TEN-THOUSAND YEARS</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter95imperialjadeseal" title="Link target outside of Sample">CHAPTER 95 - IMPERIAL JADE SEAL</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter96luoyangsanger" title="Link target outside of Sample">CHAPTER 96 - LUO YANG'S ANGER</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter97exodus" title="Link target outside of Sample">CHAPTER 97 - EXODUS</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter98breakout" title="Link target outside of Sample">CHAPTER 98 - BREAKOUT</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter99breakthrough" title="Link target outside of Sample">CHAPTER 99 - BREAK THROUGH</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter100corroboration" title="Link target outside of Sample">CHAPTER 100 - CORROBORATION</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3f6b01cd